const HEADER = 99 as const;
const DATEPICKER = 9 as const;
const DRAWER = 500 as const;
const BACKGROUND = 999 as const;
const POPUP = 999 as const;

export { HEADER, DATEPICKER, DRAWER, BACKGROUND, POPUP };
